<div class="new-content" *ngIf="!contentLoaded; else contentBlock">
  <loading-line height="40px" width="100%"></loading-line>
</div>
<ng-template #contentBlock>
  <div class="content" [class.mobile]="deviceService.isMobile()" [class.cell-row]="pane.display_mode === 'row'">
    <app-chapter [link]="blockTitle?.add_link" [title]="blockTitle.title"></app-chapter>

    <app-filter-content
      *ngIf="pane.display_mode === 'row'"
      [top]="isAsIfTeacher"
      [tabs]="categoryTabs"
      [activeTab]="selectedTab"
      (onSelect)="onSelectItem($event)">
      <ng-template action [ngIf]="isAsIfTeacher">
        <on-ui-button
          *ngIf="!deviceService.isMobile()"
          label="my-classes.actions.create-school"
          class="poutline"
          (onclick)="onToggleSchoolForm()">
        </on-ui-button>

        <div *ngIf="deviceService.isMobile()" class="create-item" (click)="onToggleSchoolForm()">
          <div class="action-icon-wrap">
            <app-icon [width]="10" [height]="10" icon="plus"></app-icon>
          </div>
        </div>
      </ng-template>
    </app-filter-content>

    <ng-container *ngIf="filteredSchools?.length && !isGuest">
      <div class="school-list" [class.mini]="pane.display_mode === 'col'">
        <div *ngFor="let school of filteredSchools; let i = index; trackBy: trackMeetingByFn" class="school-item">
          <app-school-mini
            [school]="school"
            [type]="pane.display_mode"
            (changed)="onSelectItem(selectedTab, true)"></app-school-mini>
        </div>
      </div>
      <loading-line *ngIf="pane.loading && pane.display_mode === 'row'" height="40px" width="100%"></loading-line>
      <span inViewport (inViewportAction)="onInViewportBottomChange($event)"></span>
    </ng-container>

    <ng-container
      *ngIf="(!filteredSchools?.length && pane.display_mode === 'row') || isGuest"
      [ngTemplateOutlet]="noContentStub"></ng-container>
  </div>
</ng-template>

<ng-template #noContentStub>
  <app-no-content-stub
    (click)="isAsIfTeacher ? onToggleSchoolForm() : null"
    [icon]="'stub-schools'"
    [text]="isAsIfTeacher ? 'my-classes.stub.stub6' : 'my-classes.stub.stub6_1'">
  </app-no-content-stub>
</ng-template>

<ng-template [ngIf]="newSchoolOpenForm">
  <app-modal
    *ngIf="deviceService.isDesktop(); else mobileMeetingForm"
    [canClose]="false"
    (closed)="onToggleSchoolForm()">
    <app-modal-body>
      <app-school-form [modalDisplayMode]="true" (changed)="onToggleSchoolForm($event)"> </app-school-form>
    </app-modal-body>
  </app-modal>

  <ng-template #mobileMeetingForm>
    <app-mobile-modal (closed)="onToggleSchoolForm()">
      <app-mobile-modal-title>{{ 'school-form.header' | customLocale }}</app-mobile-modal-title>
      <app-mobile-modal-body>
        <app-school-form [modalDisplayMode]="true" (changed)="onToggleSchoolForm($event)"> </app-school-form>
      </app-mobile-modal-body>
    </app-mobile-modal>
  </ng-template>
</ng-template>
